import { useState } from 'react';
import type { PushRequest } from '../components/Push/pushSummary.js';

/** Who opens the push modal and with what. The modal itself owns the preview, the ticks and the run. */
export const usePush = () => {
    const [request, setRequest] = useState<PushRequest | null>(null);
    return { request, open: (next: PushRequest) => setRequest(next), close: () => setRequest(null) };
};
